import { WorkQueueModel } from "../work-queue/work-queue.model";

export class ReportViewModel {
  reportId: number;
  genericReportTypeId: number;
  clientInfoName: string;
  clientInfoId: number;
  queueName: String;
  dateFrom: Date;
  dateTo: Date;
  generateStatus: string;
  xmlData: string;
  requestedBy: string;
  requestedDate: string;
  createdDateTime : Date;
}

export class ReportQueryModel {
  clientId: number;
  reportType: String;
  reportFromDate: Date
  reportToDate: Date

}
export class ReportQueryResultsModel {
  totalRecords: number;
  totalLenders: number;
  sufficientCoverageCount: number;
  inSufficientCoverageCount: number;
  firstNameMismatchCount: number;
  lastNameMismatchCount: number;
  addressMismatchCount: number;
  noMatchCount: number;
  data: string;

}

export class ReportQueryRowModel {
  id: number;
  'Lender Name': string;
  'Borrower 1 - Last Name': string;
  'Borrower 1 - First Name': string;
  'Borrower 2 - Last Name': string;
  'Borrower 2 - First Name': string;
  'Borrower 3 - Last Name': string;
  'Borrower 3 - First Name': string;
  'Borrower 4 - Last Name': string;
  'Borrower 4 - First Name': string;
  'Property Legal Address - Street': string;
  'City/Town': string;
  'Province/Territory': string;
  'Postal Code': string;
  'Brand': string;
  'Appraised Value': number;
  'Total RESL Principal Balance': number;
  'Product Account No. - Mortgage': string;
  'Mortgage Principal Balance': number;
  'Product Account No. - HELOC': string;
  'HELOC Principal Balance': number;
  'Borrower Language Preference': string;
  'Status (Active/Inactive)': string;
  'RESL Advance Date': string;
  'RESL Maturity Date': string;
  'Remaining Remaining Amortiation (Months)': string;
  'Mortgage Status (Active/Paid Out)': string;
  'Mortgage Type(Origination/Renewal/Refinance) ': string;
  'Company Name': string;
  'Policy Number': string;
  'Policy Effective Date': string;
  'Notice Type': string;
  'Insured 1 - Last Name(s)': string;
  'Insured 1 - First Name(s)': string;
  'Insured 2 - Last Name(s)': string;
  'Insured 2 - First Name(s)': string;
  'Insured 3 - Last Name(s)': string;
  'Insured 3 - First Name(s)': string;
  'Insured 4 - Last Name(s)': string;
  'Insured 4 - First Name(s)': string;
  'Property Legal Address': string;
  'City/Town ': string;
  'Province/Territory ': string;
  'Postal Code ': string;
  'Dwelling Coverage': number;
  'Replacement Value': number;
  'Enviornmental Risk Policy Rider': string;
  'Policy Type (New/Replacement)': string;
  'Policy Status (Cancelled/Terminated/Amended)': string;
  'Policy Received Date (@TIM)': string;
  'Policy Remediation Date': string;
  'Full Match - Coverage Sufficient (True/False)': string;
  'Insufficient Coverage Amount $(Dwelling Value - Insured Value)':string
  'No Match (True/False)': string;
  'Partial Match': string;
  'Partial Match - Reasons': string;
  'Found in Q ?': string;
  'Follow Up Date': string;
}


export class ReportCriteriaModel {
  clientId: number;
  reportType: String;
  reportDate: Date;
}
